import CalendarViewTypeEnum from '../schema/CalendarViewTypeEnum';
import { DateRangeType } from '@fluentui/date-time-utilities/lib/dateValues/dateValues';
import { assertNever } from 'owa-assert';

// NOTE -- these default values should be updated as a group so that they stay in-sync across different parts of the client (required to current architectural limitations)
//         additionally, they should align with the current default value for `CalendarViewTypeDesktop` setting as defined in Substrate:
//         https://o365exchange.visualstudio.com/O365%20Core/_git/Nibiru?path=/sources/dev/Owa/src/Client/Boot/WebServices/Models/UserConfiguration/UserConfiguration.cs&version=GBmaster
// NOTE -- do not change default to Board view without carefully auditing code and making additional changes elsewhere
export const DEFAULT_CALENDAR_VIEW_TYPE: CalendarViewTypeEnum = CalendarViewTypeEnum.Monthly;
export const DEFAULT_CALENDAR_DATE_RANGE_TYPE: DateRangeType = DateRangeType.Month;

/**
 * Converts provided calendar view type to its corresponding date range type, or else undefined
 */
export function CalendarViewTypeEnumToDateRangeType(
    viewType: CalendarViewTypeEnum
): DateRangeType | undefined {
    switch (viewType) {
        case CalendarViewTypeEnum.Daily:
            return DateRangeType.Day;
        case CalendarViewTypeEnum.Weekly:
            return DateRangeType.Week;
        case CalendarViewTypeEnum.WorkWeek:
            return DateRangeType.WorkWeek;
        case CalendarViewTypeEnum.Monthly:
            return DateRangeType.Month;
        // TODO: VSO #88707 Separate module vs surface concerns in Calendar module
        // this should be changed to undefined once module has been appropriately decoupled from surface
        case CalendarViewTypeEnum.Board:
            return DEFAULT_CALENDAR_DATE_RANGE_TYPE;
        // gracefully handle any unsupported values
        default:
            return DEFAULT_CALENDAR_DATE_RANGE_TYPE;
    }
}

/**
 * Converts provided date range type to its corresponding calendar view type
 */
export function DateRangeTypeToCalendarViewTypeEnum(
    dateRangeType: DateRangeType
): CalendarViewTypeEnum {
    switch (dateRangeType) {
        case DateRangeType.Day:
            return CalendarViewTypeEnum.Daily;
        case DateRangeType.Week:
            return CalendarViewTypeEnum.Weekly;
        case DateRangeType.WorkWeek:
            return CalendarViewTypeEnum.WorkWeek;
        case DateRangeType.Month:
            return CalendarViewTypeEnum.Monthly;
        default:
            assertNever(dateRangeType);
    }
}
